(function () {
  "use strict";
 
  /* ===== Icônes cœur ===== */
  var HEART_EMPTY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var HEART_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
 
  /* ===== Utils ===== */
  function debounce(fn, wait) { var t; return function () { clearTimeout(t); t = setTimeout(fn, wait); }; }
 
  function whenSwym(cb) {
    if (window.SwymLocalWishlist) return cb(window.SwymLocalWishlist);
    var i = 0, t = setInterval(function () {
      if (window.SwymLocalWishlist) { clearInterval(t); cb(window.SwymLocalWishlist); }
      else if (++i > 60) clearInterval(t);
    }, 250);
  }
  function refreshSwymUI() {
    try { if (window.SwymAdvancedHeaderIconAPI && SwymAdvancedHeaderIconAPI.refreshCount) SwymAdvancedHeaderIconAPI.refreshCount(); } catch (e) {}
    try { if (window.SwymGhostWishlistDrawer && SwymGhostWishlistDrawer.render) SwymGhostWishlistDrawer.render(); } catch (e) {}
  }
 
  /* Anti-boucle : ne touche au DOM QUE si l'état change vraiment (c'était la cause des gels) */
  function setBtnState(btn, on) {
    if (btn.__wl === on) return;
    btn.__wl = on;
    if (on) { btn.classList.add("is-wishlisted"); btn.innerHTML = HEART_FILLED; }
    else { btn.classList.remove("is-wishlisted"); btn.innerHTML = HEART_EMPTY; }
  }
 
  function getProductId() {
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product)
        return Number(ShopifyAnalytics.meta.product.id);
    } catch (e) {}
    var m = document.querySelector('input[name="product-id"],form[action*="/cart/add"] input[name="id"]');
    if (m) return Number(m.value);
    return null;
  }
  function getVariantId() {
    var el = document.querySelector('form[action*="/cart/add"] input[name="id"], select[name="id"]');
    return el ? Number(el.value) : null;
  }
  function buildPdpProduct() {
    var handle = (window.location.pathname.split("/products/")[1] || "").split("?")[0].split("#")[0];
    var titleEl = document.querySelector(".product-info h1, .product-title, h1");
    var imgEl = document.querySelector(".product-gallery img, .product-media img");
    var priceEl = document.querySelector('[class*="price"]');
    return {
      empi: getProductId(), epi: getVariantId(),
      du: window.location.origin + "/products/" + handle,
      dt: titleEl ? titleEl.textContent.trim() : "",
      iu: imgEl ? (imgEl.currentSrc || imgEl.src) : "",
      pr: priceEl ? priceEl.textContent.replace(/[^0-9.,]/g, "") : "",
      stk: 1
    };
  }
  function makeBtn(size) {
    var b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", "Wishlist");
    b.innerHTML = HEART_EMPTY;
    b.style.fontSize = (size || 20) + "px";
    return b;
  }
  function toggleWishlist(btn, product) {
    if (!product || !product.empi) return;
    whenSwym(function (wl) {
      wl.toggleItem(product);
      btn.__wl = undefined; /* force la mise à jour visuelle suivante */
      setBtnState(btn, wl.isWishlisted(product));
      refreshSwymUI();
    });
  }
 
  /* Cœur sur la fiche produit (à côté du titre) */
  function injectProductPageBtn() {
    if (document.querySelector(".ms-wishlist-btn--pdp")) return;
    var pi = document.querySelector(".product-info");
    if (!pi) return;
    var titleEl = pi.querySelector("h1,h2,.product-title");
    if (!titleEl) return;
    var block = titleEl.closest(".product-info__block-item") || titleEl.parentElement;
    block.style.position = "relative";
    var btn = makeBtn(22);
    btn.className = "ms-wishlist-btn ms-wishlist-btn--pdp";
    block.appendChild(btn);
    whenSwym(function (wl) { if (wl.isWishlisted(buildPdpProduct())) setBtnState(btn, true); });
    btn.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      toggleWishlist(btn, buildPdpProduct());
    });
  }
 
  /* Cœurs sur les cartes produit (grilles, cross-sell) */
  function injectCardBtns() {
    document.querySelectorAll(".product-card__figure").forEach(function (fig) {
      if (fig.querySelector(".ms-wishlist-card-btn")) return;
      var card = fig.closest(".product-card");
      var link = card ? card.querySelector("a[href*='/products/']") : null;
      if (!link) return;
      var href = link.href || link.getAttribute("href");
      var handle = href.split("/products/")[1];
      if (handle) handle = handle.split("?")[0].split("#")[0];
      if (!handle) return;
      fig.style.position = "relative";
      var btn = makeBtn(20);
      btn.className = "ms-wishlist-btn ms-wishlist-card-btn";
      btn.dataset.handle = handle;
      fig.appendChild(btn);
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        fetch("/products/" + handle + ".json").then(function (r) { return r.json(); }).then(function (data) {
          var p = data.product, v = p.variants && p.variants[0];
          toggleWishlist(btn, {
            empi: p.id, epi: v ? v.id : null,
            du: window.location.origin + "/products/" + handle,
            dt: p.title, iu: (p.images && p.images[0] && p.images[0].src) || "",
            pr: v ? v.price : "", stk: 1
          });
        }).catch(function () {});
      });
    });
    whenSwym(function (wl) {
      var items = wl.getItems() || [];
      if (!items.length) return;
      var handles = {};
      items.forEach(function (it) {
        if (it.du) { var h = it.du.split("/products/")[1]; if (h) handles[h.split("?")[0].split("#")[0]] = true; }
      });
      document.querySelectorAll(".ms-wishlist-card-btn").forEach(function (b) {
        setBtnState(b, !!handles[b.dataset.handle]);
      });
    });
  }
 
  /* Flèches galerie (scroll vertical des miniatures) */
  function handleArrowVisibility() {
    var container = document.querySelector(".product-gallery--thumbnails_left .product-gallery__media-list-wrapper");
    if (!container || container.__wlBound) return;
    container.__wlBound = true;
    function check() {
      var s = container.scrollTop, h = container.scrollHeight - container.clientHeight;
      var up = document.querySelector(".product-gallery__arrow--prev");
      var down = document.querySelector(".product-gallery__arrow--next");
      if (up) up.style.display = s <= 5 ? "none" : "";
      if (down) down.style.display = s >= h - 5 ? "none" : "";
    }
    container.addEventListener("scroll", check);
    check();
  }
 
  /* Débordement des miniatures -> affiche la flèche */
  function checkGalleryArrows() {
    document.querySelectorAll(".product-gallery__thumbnail-list").forEach(function (thumbList) {
      var gallery = thumbList.closest(".product-gallery");
      if (!gallery) return;
      var mainMedia = gallery.querySelector(".product-gallery__carousel");
      if (!mainMedia) return;
      var scrollArea = thumbList.querySelector(".scroll-area, carousel-navigation");
      if (!scrollArea) return;
      thumbList.classList.toggle("thumbs-overflow", scrollArea.scrollHeight > mainMedia.offsetHeight);
    });
    var strip = document.querySelector(".cg-strip-inner");
    if (strip) {
      var mm = document.querySelector(".product-gallery__media-list .product-gallery__media") || document.querySelector(".product-gallery__media");
      if (mm) {
        var total = 0;
        strip.querySelectorAll("button").forEach(function (thumb) {
          if (!thumb.classList.contains("cg-arrow")) {
            var cs = getComputedStyle(thumb);
            total += thumb.offsetHeight + parseInt(cs.marginTop || 0) + parseInt(cs.marginBottom || 0);
          }
        });
        strip.classList.toggle("thumbs-overflow", total > mm.offsetHeight);
      }
    }
  }
 
  /* ===== Exécution ===== */
  function run() {
    injectProductPageBtn();
    injectCardBtns();
    handleArrowVisibility();
    checkGalleryArrows();
  }
 
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(run, 300); });
  else setTimeout(run, 300);
 
  /* UN SEUL observateur, filtré + temporisé.
     Il ne réagit QU'À l'ajout de vraies cartes produit / galeries (il ignore le flot
     de mutations créé par l'ouverture des volets, les spinners, etc.) et regroupe tout
     en un seul passage. C'est ce qui supprime la surcharge / les gels sur mobile. */
  var pending = false;
  var runDebounced = debounce(function () { pending = false; run(); }, 350);
  function relevant(node) {
    if (node.nodeType !== 1 || !node.querySelector) return false;
    if (node.matches && node.matches(".product-card, .product-card__figure, .product-gallery")) return true;
    return !!node.querySelector(".product-card__figure, .product-gallery");
  }
  var mo = new MutationObserver(function (muts) {
    if (pending) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (relevant(added[j])) { pending = true; runDebounced(); return; }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
 
  window.addEventListener("resize", debounce(function () { handleArrowVisibility(); checkGalleryArrows(); }, 200));
})();
 